module.exports = __webpack_public_path__ + "images/defiscalisation.791a7dd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/defiscalisation.svg
// module id = 22
// module chunks = 0 1